import { useState, useEffect } from "react";
import { Network } from "@capacitor/network";
import { Capacitor } from "@capacitor/core";

export default function useOnlineStatus() {
    const [isOnline, setIsOnline] = useState(true);

    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return;

        let listenerHandle;

        // Pehli baar current status le lo
        const init = async () => {
            const status = await Network.getStatus();
            setIsOnline(status.connected);
        };
        init();

        // Status change pe listen karo — native event, instant aur reliable
        const setup = async () => {
            listenerHandle = await Network.addListener(
                "networkStatusChange",
                (status) => {
                    setIsOnline(status.connected);
                }
            );
        };
        setup();

        return () => {
            if (listenerHandle) listenerHandle.remove();
        };
    }, []);

    return isOnline;
}






// import { useState, useEffect } from "react";

// // Sirf navigator.onLine pe bharosa nahi karte (ye kabhi-kabhi galat batata hai),
// // isliye offline hone par actual ping karke confirm karte hain.
// export default function useOnlineStatus() {
//   const [isOnline, setIsOnline] = useState(navigator.onLine);

//   useEffect(() => {
//     let pingTimer;

//     const checkConnection = async () => {
//       try {
//         //await fetch("https://doctora.live/assets/favicon.ico", {
//         await fetch("https://www.google.com/favicon.ico", {
//           method: "HEAD",
//           mode: "no-cors",
//           cache: "no-store",
//         });
//         setIsOnline(true);
//       } catch {
//         setIsOnline(false);
//       }
//     };

//     const handleOnline = () => checkConnection();
//     const handleOffline = () => setIsOnline(false);

//     window.addEventListener("online", handleOnline);
//     window.addEventListener("offline", handleOffline);

//     if (!isOnline) {
//       pingTimer = setInterval(checkConnection, 3000);
//     }

//     return () => {
//       window.removeEventListener("online", handleOnline);
//       window.removeEventListener("offline", handleOffline);
//       if (pingTimer) clearInterval(pingTimer);
//     };
//   }, [isOnline]);

//   return isOnline;
// }